  <template >
   <div class="formPosition" v-role="roles">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
         <span>Relatório de Cadeirantes</span>

                 <v-icon large color="green darken-2">forward</v-icon>

      </v-col>
          <v-col md="2">
             <v-select
              :items="cursos"
              v-model="cursoSelected"
              item-value="descricao"
              item-text="descricao"
              @change="SelecionaCurso()"
              label="Selecione o Curso"
              return-object
            ></v-select>
      </v-col>
      <v-col md="2">
             <v-select
              :items="disciplinas"
              v-model="disciplinaSelected"
              item-value="descricao"
              item-text="descricao"
              @change=" SelecionaDisciplina()"
              label="Selecione a disciplina"
              return-object
            ></v-select>
      </v-col>
      <v-col md="2">
             <v-select
              :items="Listaranoslectivo"
              v-model="anolectivoSelected"
              item-value="descricao"
              item-text="novadescricao"
              @change="FiltraAnolectivo()"
              label="Selecione o Ano lectivo"
            ></v-select>
      </v-col>
      <v-col md="2">
             <v-btn color="primary" @click="GerarRelatorio()" style="color:white" rounded :disabled="cursoSelected === null || disciplinaSelected === null || anolectivoSelecionado === null">Gerar Relatório</v-btn>
      </v-col>
    </v-row>
  </v-container>
  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {

  data: () => ({
    anolectivoSelected: ls.get('anolectivo'),
    Listaranoslectivo: [],
    disciplinas: [],
    cursos: [],
    cursoSelected: null,
    disciplinaSelected: null,
    roles: 'func'
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // this.initializeAnosLectivo()
    this.initializeCursos()
    // Seta o anolectivo padrão
    this.$store.state.anolectivoSelecionado = this.anolectivoSelected
  },

  methods: {
    classe (idclasse) {
      const ls = require('local-storage')
      this.$store.state.idclasse = idclasse
      if (idclasse === 1) {
        this.$store.state.classeTur = '10ªC-' + ls.get('anolectivo')
      } else if (idclasse === 2) {
        this.$store.state.classeTur = '11ªC-' + ls.get('anolectivo')
      } else if (idclasse === 3) {
        this.$store.state.classeTur = '12ªC-' + ls.get('anolectivo')
      } else if (idclasse === 4) {
        this.$store.state.classeTur = '13ªC-' + ls.get('anolectivo')
      }
      this.$router.push('turmacrud')

      //  this.$store.dispatch('setidclasse', idclasse)
    },

    async initializeAnosLectivo () {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    },

    async initializeCursos () {
      try {
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    },

    async initializeDisciplinas () {
      try {
        this.disciplinas = await axios
          .get('/disciplinaFindAll/' + this.cursoSelected.idCurso)
          .then(res => res.data)
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    },

    FiltraAnolectivo () {
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected
    },
    async  SelecionaCurso () {
      this.initializeDisciplinas()
    },
    async  SelecionaDisciplina () {
      this.initializeAnosLectivo()
    },
    GerarRelatorio () {
      let params = {
        iddisciplina: this.disciplinaSelected.iddisciplina,
        anolectivo: this.anolectivoSelected,
        disciplina: this.disciplinaSelected.descricao,
        curso: this.cursoSelected.descricao
      }

      this.$store.state.objEstudante = params
      this.$router.push('listagem-relatorio-cadeira')
    }
  }
}
</script>
